import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { useStyleStore } from "@bloglovin/vue-component-library";

// Lazy store resolution: a module-scope import here closes a cycle
// (stores -> components -> mixins -> classes). See scripts/find-import-cycles.py.
// eslint-disable-next-line global-require
const useDynamicComponentStore = (...args) => require("%/dynamic-component-editor/stores/dynamic-component-store").default(...args);


export default class BoxShadow extends BaseOption {
  static userInterfaceComponent = {
    label: "Box Shadow",
    component: inspectorTools.SHADOW_PICKER,
    useCustomLabel: true,
    useVerticalOrientation: true,
    useDefaultVariableLinking: false,
    canSetOtherStates: [BaseOption.$states.HOVER],
    props: {
      multiple: true,
      title: "Box Shadow",
      schema: {
        fields: {
          color: true,
          blur: true,
          offsetX: true,
          offsetY: true,
          spread: true,
          inset: true,
        },
        defaultShadow() {
          return {
            color: { value: "standard", source: "theme.border" },
            blur: 2,
            offsetX: 2,
            offsetY: 2,
            spread: 2,
            inset: false,
          };
        },
      },
    },
  };

  static defaultValue = [];

  static convertConfigValueToCompiledValue(configValue, themeId) {
    let boxShadowStrings = [];

    if (!configValue) {
      return "";
    }

    if (themeId === undefined || themeId === null) {
      themeId = useDynamicComponentStore().themeId;
    }

    configValue.forEach(shadow => {
      let shadowString = "";

      if (shadow.inset) {
        shadowString += "inset";
      }

      ["offsetX", "offsetY", "blur", "spread"].forEach(prop => {
        const formatted = this.formatShadowValue(shadow[prop]);
        shadowString += ` ${formatted}px`;
      });

      if (shadow.color !== null) {
        shadowString += ` ${BoxShadow.getBoxShadowColor(shadow.color, themeId)}`;
      }

      boxShadowStrings.push(shadowString);
    });

    return boxShadowStrings.join(",") || "none";
  }

  static getBoxShadowColor(option, themeId, themeMode = "inherit") {
    const styleStore = useStyleStore();
    let palette = styleStore.themePalettes[themeId];
    if (option.source.includes("semantic")) {
      palette = styleStore.getSemanticPaletteFromMode(themeId, themeMode);
    }
    return BaseOption.getColorValue(option, styleStore.themes[themeId], palette, themeId, themeMode);
  }
}
